var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import styles from './index.css';
import { LoginDialog } from '../../..';
import { LoginIdContext } from '../utils/loginId';
import { getHotList } from '../utils/api';
import HotList from './hotList';
import CommentTextarea from './commentTextarea';
import Checkmore from './checkMore';
import JubDialog from './jubDialog';
import BannerAd from './bannerAd';
import Pagination from './pagination';
class CommentComp extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            allow_comment: -1,
            hotListData: {
                count: 0,
                join_count: 0,
                comments: [],
            },
            recentData: {
                count: 0,
                comments: [],
            },
            curPage: 1,
        };
        this.handlePaginationClick = (page) => __awaiter(this, void 0, void 0, function* () {
            const { articleInfo } = this.props;
            const { cmtNumUrl, docUrl, skey, recentLimit = 10, recentReplyLimit } = articleInfo;
            try {
                // 最新列表
                const recentData = yield getHotList(cmtNumUrl, docUrl, skey, page, recentLimit, recentReplyLimit, 'create_time');
                this.setState({
                    allow_comment: recentData.allow_comment,
                    hotListData: Object.assign(Object.assign({}, this.state.hotListData), { comments: [] }),
                    recentData,
                    curPage: page,
                });
                // 点击翻页后回到页面顶部
                if (window) {
                    window.scrollTo(0, 0);
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        this.onSubmit = (content) => {
            // 发布后回显一次
            const { articleInfo: { docUrl, order, showTempComment }, } = this.props;
            if (showTempComment && order && (order === 'create_time' || order === 'both')) {
                const commentDetail = {
                    isTemp: true,
                    contents: content,
                    docUrl,
                    year: new Date().getFullYear(),
                    date: new Date().getMonth() + 1 > 9 ? new Date().getMonth() + 1 : `0${new Date().getMonth() + 1 > 9}`,
                    time: `${new Date().getDate() > 9 ? new Date().getDate() : `0${new Date().getDate()}`} ${new Date().getHours() > 9 ? new Date().getHours() : `0${new Date().getHours()}`}:${new Date().getMinutes() > 9 ? new Date().getMinutes() : `0${new Date().getMinutes()}`}`,
                };
                this.setState({
                    recentData: Object.assign(Object.assign({}, this.state.recentData), { comments: [commentDetail, ...this.state.recentData.comments] }),
                });
            }
        };
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            const { articleInfo } = this.props;
            const { cmtNumUrl, docUrl, skey, hotLimit, replyLimit, order, recentLimit = 10, recentReplyLimit, showTempComment, } = articleInfo;
            if (order) {
                if (order === 'both') {
                    try {
                        // 最热列表
                        const hotListData = yield getHotList(cmtNumUrl, docUrl, skey, 1, hotLimit, replyLimit);
                        this.setState({
                            allow_comment: hotListData.allow_comment,
                            hotListData,
                        });
                    }
                    catch (e) {
                        console.error(e);
                    }
                    try {
                        // 最新列表
                        const recentData = yield getHotList(cmtNumUrl, docUrl, skey, 1, recentLimit, recentReplyLimit, 'create_time');
                        console.log(recentData);
                        this.setState({
                            allow_comment: recentData.allow_comment,
                            recentData,
                        });
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                else if (order === 'create_time') {
                    try {
                        const recentData = yield getHotList(cmtNumUrl, docUrl, skey, 1, recentLimit, recentReplyLimit, 'create_time');
                        this.setState({
                            allow_comment: recentData.allow_comment,
                            recentData,
                        });
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                else {
                    try {
                        const hotListData = yield getHotList(cmtNumUrl, docUrl, skey, 1, hotLimit, replyLimit);
                        this.setState({
                            allow_comment: hotListData.allow_comment,
                            hotListData,
                        });
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            }
            else {
                try {
                    const hotListData = yield getHotList(cmtNumUrl, docUrl, skey, 1, hotLimit, replyLimit);
                    this.setState({
                        allow_comment: hotListData.allow_comment,
                        hotListData,
                    });
                }
                catch (e) {
                    console.error(e);
                }
            }
            // if (showTempComment && order && (order === 'create_time' || order === 'both')) {
            //     try {
            //         const tempListData = await getTempCommentList(docUrl, replyLimit);
            //         if (
            //             tempListData &&
            //             Object.prototype.toString.call(tempListData) === '[object Array]' &&
            //             tempListData.length > 0
            //         ) {
            //             this.setState({
            //                 recentData: {
            //                     ...this.state.recentData,
            //                     comments: [...tempListData, ...this.state.recentData.comments],
            //                 },
            //             });
            //         }
            //     } catch (e) {
            //         console.error(e);
            //     }
            // }
        });
    }
    render() {
        const { hotListData, recentData, allow_comment, curPage } = this.state;
        const { articleInfo, loginId, jubShow, handleJubShow, jubCommentId } = this.props;
        const commentTextareaData = {
            count: hotListData.count ? hotListData.count : 0,
            joinCount: hotListData.join_count ? hotListData.join_count : 0,
            noAd: articleInfo.noAd,
            docUrl: articleInfo.docUrl,
            docName: articleInfo.docTitle,
            skey: articleInfo.skey,
            pcUrl: articleInfo.pcUrl,
        };
        const checkmoreData = {
            noAd: articleInfo.noAd,
            isComment: articleInfo.isComment,
            docUrl: articleInfo.docUrl,
            docName: articleInfo.docTitle,
            skey: articleInfo.skey,
            pcUrl: articleInfo.pcUrl,
        };
        let comment_list = null;
        let intervalBannerAd = null;
        if (articleInfo.hasIntervalBannerAd && articleInfo.intervalBannerAdData) {
            intervalBannerAd = (React.createElement(BannerAd, { content: articleInfo.intervalBannerAdData, styleName: articleInfo.intervalBannerAdStyle }));
        }
        if (articleInfo.options === 0) {
            comment_list = (React.createElement(React.Fragment, null,
                recentData.comments ? (React.createElement(HotList, { tag: "recent", content: recentData, limitHeight: articleInfo.limitHeight || '', showEmptyCommentTip: articleInfo.showEmptyCommentTip || false, allow_comment: allow_comment, curPage: curPage })) : (''),
                intervalBannerAd,
                hotListData.comments ? (React.createElement(HotList, { content: hotListData, limitHeight: articleInfo.limitHeight || '', allow_comment: allow_comment, curPage: curPage })) : ('')));
        }
        else {
            comment_list = (React.createElement(React.Fragment, null,
                hotListData.comments ? (React.createElement(HotList, { content: hotListData, limitHeight: articleInfo.limitHeight || '', allow_comment: allow_comment, curPage: curPage })) : (''),
                intervalBannerAd,
                recentData.comments ? (React.createElement(HotList, { tag: "recent", content: recentData, limitHeight: articleInfo.limitHeight || '', showEmptyCommentTip: articleInfo.showEmptyCommentTip || false, allow_comment: allow_comment, curPage: curPage })) : ('')));
        }
        return allow_comment !== -1 ? (React.createElement("div", { className: styles.comment_box },
            comment_list,
            React.createElement(React.Fragment, null,
                React.createElement(LoginIdContext.Consumer, null, (value) => (React.createElement(CommentTextarea, { content: commentTextareaData, loginId: value.loginId, config: value.config, userInfo: value.userInfo, myComUrl: value.myComUrl, onSubmit: this.onSubmit }))),
                React.createElement(Checkmore, { content: checkmoreData }),
                articleInfo.usePagination ? (React.createElement(Pagination, { total: recentData.count, pageSize: articleInfo.recentLimit, handleClick: this.handlePaginationClick })) : null),
            React.createElement(LoginDialog, { id: loginId }),
            jubShow ? (React.createElement(JubDialog, { handleJubShow: handleJubShow, jubCommentId: jubCommentId, jubUrl: articleInfo.jubUrl })) : (''))) : null;
    }
}
CommentComp.defaultProps = {
    articleInfo: {
        cmtLength: 1000,
        hotLimit: 10,
        recentLimit: 10,
        replyLimit: 5,
    },
};
export default CommentComp;
